import { Avatar, AvatarGroup } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  getCompany,
  getInternshipRequest,
  getInternStudent,
  getJoinDataByCompany,
} from "../../api/crud";
import { useNavigate } from "react-router-dom";

import { optionsBranch } from "../../data/branch-data";
import { internType } from "../../data/interntype-data";
import { matchOptions } from "../../utils/function";
import DrawerView from "../DrawerView";
import FormReview from "../FormReview";
import InternData from "../InternData";
import ModalView from "../ModalView";
import ProfileDetail from "../ProfileDetail";
import { IoMdRemoveCircle } from "react-icons/io";
import DrawerReviewCompany from "./DrawerReviewCompany";
import InternPersonsQty from "../InternPersonsQty";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { FaRegCommentDots } from "react-icons/fa";
import { useSelector } from "react-redux";
import PopoverComp from "../PopoverComp";

const DocRequest = () => {
  const navigate = useNavigate();
  const [companyWithIntern, setcompanyWithIntern] = useState([]);
  const [companyWithInternEdit, setcompanyWithInternEdit] = useState([]);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [companySelected, setCompanySelected] = useState(null);
  const [isModalProfileOpen, setIsModalProfileOpen] = useState();
  const [joinDataByCompany, setJoinDataByCompany] = useState([]);
  const profile = useSelector((state) => state.profileReducer.profile);
  const [studentIdSelected, setStudentIdSelected] = useState(null);
  const [removeStudent, setRemoveStudent] = useState([]);

  const onSelectCompany = (company) => {
    setIsOpenDrawer(true);
    setCompanySelected(company);
  };

  const getData = async () => {
    const internStudent = await getInternStudent();
    const allCompany = await getCompany();
    const internshipRequest = await getInternshipRequest();

    const filterStudent = internStudent.filter((st) => st.status_id == 12);

    const studentDetail = filterStudent.map((st) => {
      const find = internshipRequest.find((el) => el.st_id == st.id);
      // const find = internshipRequest
      //   .filter((req) => req.st_id == st.id)
      //   .sort((a, b) => b.req_id - a.req_id)[0];

      return {
        ...st,
        internDetail: find,
      };
    });

    const companyWithStd = allCompany
      .map((company) => {
        const internSt = studentDetail.filter(
          (st) => st.internDetail?.cp_id == company.id
        );

        return {
          ...company,
          internStudent: internSt,
        };
      })
      .filter((item) => item.internStudent.length);

    setcompanyWithIntern(companyWithStd);
    setcompanyWithInternEdit(companyWithStd);
  };

  const onRemoveStudent = (stId, companyObj) => {
    setRemoveStudent((std) => [...std, stId]);

    const newInternStudent = companyObj.internStudent.filter(
      (el) => el.id !== stId
    );

    const newCompanyObj = {
      ...companyObj,
      internStudent: newInternStudent,
    };

    const newCompanyArray = companyWithInternEdit.map((company) => {
      return company.id == companyObj.id ? newCompanyObj : company;
    });

    setcompanyWithInternEdit(newCompanyArray);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getJoinDataByCompany().then((res) => {
      setJoinDataByCompany(res);
    });
  }, []);

  console.log({ companyWithInternEdit });

  return (
    <div>
      <div className="card">
        <div className="card-header d-flex justify-content-between">
          <h3>สร้างหนังสือขอความอนุเคราะห์</h3>
          <div
            className="btn  btn-outline-warning btn-sm"
            onClick={() => navigate(0)}
          >
            Refresh
          </div>
        </div>
        <div className="card-body">
          <div style={{ height: "35px" }} />
          <div id="tasks-upcoming">
            {!!companyWithInternEdit.length &&
              companyWithInternEdit.map((el, index) => {
                return (
                  <div key={index} className="card mb-3 bg-light  border">
                    <div className="card-body p-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          <h6>{el.name}</h6>
                          <InternPersonsQty
                            companyDetail={joinDataByCompany.find(
                              (c) => c.id == el.id
                            )}
                          />
                        </div>
                        <div className="badge bg-info">ID : {el.id}</div>
                      </div>

                      <p>
                        {el?.address} ต.
                        {el?.subdistrict} อ.
                        {el?.district} จ.
                        {el?.province} {el?.zip}
                      </p>
                      <div>
                        <AvatarGroup total={el.internStudent.length}>
                          {el.internStudent.length &&
                            el.internStudent.map((st, stIndex) => {
                              return (
                                <Avatar
                                  key={stIndex}
                                  alt={st.name}
                                  sx={{ height: 50, width: 50 }}
                                  src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${st.id}`}
                                />
                              );
                            })}
                        </AvatarGroup>
                      </div>

                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <div
                            className="btn btn-primary btn-sm"
                            onClick={() => onSelectCompany(el)}
                          >
                            ดูตัวอย่าง
                          </div>
                          <div
                            className="btn btn-outline-primary btn-sm ms-1"
                            data-bs-toggle="collapse"
                            data-bs-target={`#docRequestCollapse-${index}`}
                            aria-expanded="false"
                            aria-controls={`docRequestCollapse-${index}`}
                          >
                            ตรวจสอบข้อมูลนิสิต
                          </div>
                        </div>
                        {el.internStudent.length && (
                          <span className="badge bg-success">
                            {matchOptions(
                              internType,
                              el.internStudent[0].internDetail.type_internship
                            )}
                          </span>
                        )}
                      </div>

                      <div
                        className="collapse pt-3"
                        id={`docRequestCollapse-${index}`}
                      >
                        <div className="card card-body">
                          <div className="list-group">
                            {el.internStudent.length &&
                              el.internStudent.map((st, stIndex) => {
                                const { type_internship, req_id } =
                                  st.internDetail;

                                return (
                                  <div className="">
                                    <div className="d-flex w-100 justify-content-between">
                                      <div className="d-flex align-items-center">
                                        <div
                                          type="button"
                                          onClick={() => {
                                            setIsModalProfileOpen(true);
                                            setStudentIdSelected(st.id);
                                          }}
                                        >
                                          <span>{st.id} </span>
                                          <span>{st.name}</span>
                                        </div>{" "}
                                        <span className="ms-2">
                                          {st?.internDetail?.comment &&
                                            st?.internDetail?.comment !==
                                              "-" && (
                                              <PopoverComp
                                                label={<FaRegCommentDots />}
                                                popoverText={
                                                  st.internDetail.comment
                                                }
                                              />
                                            )}
                                        </span>
                                      </div>

                                      <div>
                                        {el.internStudent.length > 1 && (
                                          <IoMdRemoveCircle
                                            color="red"
                                            role="button"
                                            size="1.5rem"
                                            onClick={() =>
                                              onRemoveStudent(st.id, el)
                                            }
                                          />
                                        )}
                                        <span className="dropdown">
                                          <BiDotsVerticalRounded
                                            size="1.5rem"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          />
                                          <ul className="dropdown-menu">
                                            <li>
                                              <form
                                                action="./cancel-company-select.php"
                                                method="post"
                                              >
                                                <input
                                                  className="d-none"
                                                  defaultValue={req_id}
                                                  name="req_id"
                                                />
                                                <input
                                                  className="d-none"
                                                  defaultValue={st?.id}
                                                  name="st_id"
                                                />
                                                <input
                                                  className="d-none"
                                                  defaultValue={profile?.id}
                                                  name="user"
                                                />
                                                <button
                                                  className="btn btn-light dropdown-item"
                                                  type="submit"
                                                >
                                                  ยกเลิก
                                                </button>
                                              </form>
                                            </li>
                                          </ul>
                                        </span>
                                      </div>
                                    </div>
                                    <div>
                                      <span className="badge bg-secondary me-2">
                                        {matchOptions(optionsBranch, st.b_id)}
                                      </span>
                                      <span
                                        className={`badge ${
                                          type_internship == 1
                                            ? "bg-success"
                                            : type_internship == 2
                                            ? "bg-info"
                                            : "bg-warning"
                                        }`}
                                      >
                                        {matchOptions(
                                          internType,
                                          type_internship
                                        )}
                                      </span>
                                    </div>
                                    <hr />
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      <DrawerView
        isOpen={isOpenDrawer}
        setIsOpen={setIsOpenDrawer}
        content={
          <FormReview
            companyId={companySelected?.id}
            removeStudent={removeStudent}
          />
        }
      />

      <ModalView
        isModaOpen={isModalProfileOpen}
        setIsModalOpen={setIsModalProfileOpen}
      >
        <div className="row w-100" style={{ margin: "0 auto" }}>
          <div className="col-md-6">
            <ProfileDetail st_id={studentIdSelected} />
          </div>
          <div className="col-md-6">
            <InternData st_id={studentIdSelected} />
          </div>
        </div>
      </ModalView>
    </div>
  );
};

export default DocRequest;
